var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.547 44.4238C33.8266 44.4238 30 48.2505 30 52.9708V64.723C30 69.4434 33.8266 73.27 38.547 73.27H44.4231V87.6929H51.6346V73.27H58.8462V44.4238H38.547Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8438 44.4231L86.2668 30.7115C86.9206 30.3846 87.6899 30.8601 87.6899 31.5911V86.1012C87.6899 86.8322 86.9206 87.3077 86.2668 86.9808L58.8438 73.2692V44.4231Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjYwIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM4LjU0NyA0NC40MjM4QzMzLjgyNjYgNDQuNDIzOCAzMCA0OC4yNTA1IDMwIDUyLjk3MDhWNjQuNzIzQzMwIDY5LjQ0MzQgMzMuODI2NiA3My4yNyAzOC41NDcgNzMuMjdINDQuNDIzMVY4Ny42OTI5SDUxLjYzNDZWNzMuMjdINTguODQ2MlY0NC40MjM4SDM4LjU0N1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik01OC44NDM4IDQ0LjQyMzFMODYuMjY2OCAzMC43MTE1Qzg2LjkyMDYgMzAuMzg0NiA4Ny42ODk5IDMwLjg2MDEgODcuNjg5OSAzMS41OTExVjg2LjEwMTJDODcuNjg5OSA4Ni44MzIyIDg2LjkyMDYgODcuMzA3NyA4Ni4yNjY4IDg2Ljk4MDhMNTguODQzOCA3My4yNjkyVjQ0LjQyMzFaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjI1Ii8+Cjwvc3ZnPgo=";
export { SvgNotification as ReactComponent };